  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          
          <div class="form-group row">
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                formControlName="Naziv"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'PROIZVODJAC.NAZIV.SINGULAR'"
                [MaxLength]="50">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                <span *ngFor="let validation of errorMessages.Naziv">
                  <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist
                [ModelName]="'proizvodjac'"
                [GetName]="'getRoot'"
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="TataID"
                [Label]="'PROIZVODJAC.TATAID.SINGULAR'"
                [Type]="'treeview'">
              </yt-dropdown-picklist>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist
              [ModelName]="'komitent'"
              [GetName]="'get'"
              [ModelProperty]="'SNaziv,Mesto'"
              [OrderBy]="'SNaziv'"
              [AllowAddNew]="true"
              formControlName="GlavniDobavljacID"
              [Label]="'PROIZVODJAC.GLAVNIDOBAVLJACID.SINGULAR'"
              [Width]="'600px'"
              [Position]="'left'"              
              >
              </yt-dropdown-picklist>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>